<form *ngIf="form" [formGroup]="form" class="res-b-form" fxLayout="row wrap" fxLayoutAlign="center start">
    <app-wok-question
        *ngIf="resourceBuilderService.selectedWOKQuestionType | async; let questionType"
        fxFlex="0 1 100%"
        [questionType]="questionType | cast"
    ></app-wok-question>
    <app-questions-items
        *ngIf="isResourceTypeWithQuestions"
        fxFlex="0 1 100%"
        formArrayName="items"
        [itemFormArray]="form.get('items') | cast"
        [items]="items | async"
        [usePoints]="usePoints"
    ></app-questions-items>
    <app-resource-items
        *ngIf="!isResourceTypeWithQuestions"
        fxFlex="0 1 100%"
        formArrayName="items"
        [itemFormArray]="form.get('items') | cast"
        [items]="items | async"
        [resourceForm]="resourceForm"
        [usePoints]="usePoints"
        (onSubmitThenRoute)="onSubmitThenRoute($event)"
    ></app-resource-items>
</form>
